export const experience = [
  {
    period: "May 2026 — Jun 2026",
    role: "Fullstack Developer Trainee",
    company: "Innoblooms",
    points: [
      "Developed and maintained frontend features for a School Management System using Next.js, TypeScript, and Material UI.",
      "Integrated REST APIs to connect frontend components with backend services across Admin, Super Admin, Teacher, and Student panels.",
      "Built responsive, user-friendly interfaces for dashboards, examinations, student management, results, and data visualization.",
      "Contributed to deploying and maintaining the application in a production environment.",
    ],
    tags: ["Next.js", "TypeScript", "Material UI", "REST APIs"],
  },
  {
    period: "Jul 2025 — Jan 2026",
    role: "Software Developer Intern",
    company: "Inforida",
    companyUrl: "https://www.inforida.com/products/nucleus",
    points: [
      "Developed and maintained a fully responsive Angular-based company website using modular component architecture, ensuring optimal performance across mobile, tablet, and desktop.",
      "Collaborated with the design and backend teams to integrate APIs and deliver feature updates on schedule.",
      "Improved codebase quality through code reviews, reusable component design, and adherence to best practices.",
    ],
    tags: ["Angular", "Component Architecture", "REST APIs"],
  },
];
